import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Upload,
} from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { GET_LOAD_IMAGE, POST_LOAD_ASSET } from "../../../API/apiUrls";

const { Option } = Select;
const { confirm } = Modal;

function ModelViewData({ open, close, index, dataForView, provinces, datas }) {
  const [loading, setLoading] = useState(false);
  const [getimages, setGetImages] = useState([]); // รูปภาพทั้งหมด
  const token = localStorage.getItem("TOKEN");
  const [form] = Form.useForm(); // form หลัก
  const [seizedForm] = Form.useForm(); // ติดอายัด
  const [mortgageForm] = Form.useForm(); // ติดจำนอง, ติดขายฝาก
  const [ch, setCh] = useState([]); // checkbox ติดอายัด,ติดจำนอง,ติดขายฝาก
  const [loadData, setLoadData] = useState(false); // state ไว้เก็บข้อมูลเจ้าของทรัพย์
  const [assetCustomer, setAssetCustomer] = useState([]); // state ไว้เก็บข้อมูลเจ้าของทรัพย์
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAddasset();
  }, [loadData]);

  // console.log("dataAssetList", dataAssetList);
  // console.log("imagesBackup", imagesBackup);
  // console.log("getimages", getimages);
  // console.log("dataForView", dataForView);
  // console.log("provinces", provinces);
  // console.log("index", index);
  // console.log("datas", datas);

  //  Load data
  const loadAddasset = async () => {
    // โหลดจังหวัด
    const params = { assetId: dataForView ? dataForView?.assetId : 0 };
    console.log("params", params);

    try {
      setLoading(true);
      const response = await axios.post(POST_LOAD_ASSET, params, {
        headers: {
          Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
        },
      });
      console.log("response loadAssetData", response?.data?.assetLandArea);
      if (response?.data) {
        setAssetCustomer(
          response?.data?.assetLandArea[index]?.contractLandCustomer
        );
        setCh(response?.data?.assetLandArea[index]?.landAreaStatus);
        setGetImages(response?.data?.urlPath ? [response?.data?.urlPath] : []);
        setLoadData(false);

        // เซตฟอร์ม
        if (
          response?.data?.assetLandArea[index]?.assetSeized?.assetSeizedId !== 0
        ) {
          seizedForm.setFieldsValue({
            ...response?.data?.assetLandArea[index]?.assetSeized,
          });
        } else {
          mortgageForm.setFieldsValue({
            ...response?.data?.assetLandArea[index]?.assetMortgage,
          });
        }

        form.setFieldsValue({
          ...response?.data?.assetLandArea[index],
        });
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    close(false);
  };

  return (
    <Modal open={open} onCancel={handleClose} width={1200} footer={null}>
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Row justify={"center"}>
          <h2>ข้อมูลทรัพย์สิน</h2>
        </Row>
        <Row justify="center" gutter={[16, 16]} style={{ width: "100%" }}>
          {/* ---------------------------- ติดอายัด ติดจำนอง ติดขายฝาก ---------------------------- */}
          <Col xs={24} md={12}>
            {ch === 1 ? ( // กรณีติดอายัด
              <Card
                size="small"
                title={
                  <div style={{ textAlign: "center" }}>
                    รายละเอียดกรณีติดอายัด
                  </div>
                }
                bordered={false}
                style={{ padding: "12px" }}
              >
                <Form form={seizedForm} layout="vertical" disabled>
                  <Form.Item
                    label="ชื่อเจ้าของคำพิพากษา"
                    name="judgementOwner"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกชื่อเจ้าของคำพิพากษา",
                      },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="เลขคดีแดง"
                    name="caseNumber"
                    rules={[{ required: true, message: "กรุณากรอกเลขคดีแดง" }]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="ราคาประเมิน"
                    name="valuationPrice"
                    rules={[
                      { required: true, message: "กรุณากรอกราคาประเมิน" },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="เจ้าพนักงานบังคับคดี"
                    name="enforcementOfficer"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกเจ้าพนักงานบังคับคดี",
                      },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="ชื่อสำนักงาน"
                    name="officeName"
                    rules={[
                      { required: true, message: "กรุณากรอกชื่อสำนักงาน" },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                </Form>
              </Card>
            ) : ch === 2 || ch === 3 ? ( // กรณีติดจำนอง/ขายฝาก
              <Card
                size="small"
                title={
                  <div style={{ textAlign: "center" }}>
                    รายละเอียดกรณีติดจำนอง/ขายฝาก
                  </div>
                }
                bordered={false}
                style={{ padding: "12px" }}
              >
                <Form
                  form={mortgageForm}
                  layout="vertical"
                  disabled
                  // initialValues={datasendForEdit[index]?.assetMortgage || {}}
                  // onValuesChange={(changedValues, allValues) =>
                  //     handleFormChange(index, "mortgageData", allValues)
                  // }
                >
                  <Form.Item
                    label="เจ้าหนี้จำนอง"
                    name="mortgageCreditor"
                    rules={[
                      { required: true, message: "กรุณากรอกเจ้าหนี้จำนอง" },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="วันทำสัญญา"
                    name="contractDate"
                    rules={[
                      { required: true, message: "กรุณาเลือกวันทำสัญญา" },
                    ]}
                  >
                    <DatePicker style={{ width: "100%", height: "40px" }} />
                  </Form.Item>
                  <Form.Item
                    label="ยอดหนี้จำนอง"
                    name="mortgageDebt"
                    rules={[
                      { required: true, message: "กรุณากรอกยอดหนี้จำนอง" },
                    ]}
                  >
                    <Input style={{ color: "black" }} />
                  </Form.Item>
                  <Form.Item
                    label="กำหนดไถ่ถอน"
                    name="redemptionDate"
                    rules={[
                      { required: true, message: "กรุณาเลือกกำหนดไถ่ถอน" },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px", color: "black" }}
                    />
                  </Form.Item>
                </Form>
              </Card>
            ) : (
              <Row
                justify="center"
                align="middle"
                style={{ minHeight: "100%", display: "flex" }}
              >
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Card style={{ textAlign: "center", border: "none" }}>
                    <h2>ติ๊ก checkbox สถานะภาระทรัพย์เพื่อโชว์ฟอร์ม</h2>
                  </Card>
                </Col>
              </Row>
            )}
          </Col>
          {/* ---------------------------- รายละเอียดที่ดิน ---------------------------- */}
          <Col xs={24} md={12}>
            <Card
              // title="รายละเอียดที่ดิน"
              title={
                <div style={{ textAlign: "center" }}>รายละเอียดที่ดิน</div>
              }
              style={{ padding: "12px" }}
              bordered={false}
            >
              <Form
                form={form}
                layout="vertical"
                disabled // ✅ ทั้งฟอร์มแก้ไม่ได้
                // initialValues={guarantorAssetData[index] || {}}
                // onValuesChange={handleFormChanges}
              >
                <Row justify={"center"}>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="เลขที่ดิน"
                      name="numberLand"
                      rules={[
                        { required: true, message: "กรุณากรอกเลขที่ดิน" },
                      ]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="เลขระวาง"
                      name="numberLandlawang"
                      rules={[{ required: true, message: "กรุณากรอกเลขระวาง" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="จังหวัด"
                      name="provinceName"
                      rules={[{ required: true, message: "กรุณากรอกจังหวัด" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="อำเภอ"
                      name="districtName"
                      rules={[{ required: true, message: "กรุณากรอกอำเภอ" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "left" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ตำบล"
                      name="subdistrictName"
                      rules={[{ required: true, message: "กรุณากรอกตำบล" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="รหัสไปรษณีย์"
                      name="zipcode"
                      rules={[
                        { required: true, message: "กรุณากรอกรหัสไปรษณีย์" },
                      ]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ราคาที่ดิน"
                      name="landPrice"
                      rules={[
                        { required: true, message: "กรุณากรอกราคาที่ดิน" },
                      ]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ชื่อสถานที่"
                      name="nameMap"
                      rules={[
                        { required: true, message: "กรุณากรอกชื่อสถานที่" },
                      ]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ละติจูด"
                      name="lat"
                      rules={[{ required: true, message: "กรุณากรอกละติจูด" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                    <Form.Item
                      style={{ width: "90%" }}
                      label="ลองจิจูด"
                      name="lng"
                      rules={[{ required: true, message: "กรุณากรอกลองจิจูด" }]}
                    >
                      <Input style={{ color: "black" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
        <Row justify={"center"} gutter={[16, 16]} style={{ width: "100%" }}>
          <Col span={24} style={{ textAlign: "center", marginBottom: 4 }}>
            {assetCustomer?.length > 0 ? (
              <>
                <h4
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginBottom: "12px",
                  }}
                >
                  เจ้าของทรัพย์ที่มี
                </h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "8px",
                  }}
                >
                  {assetCustomer?.map((owner, idx) => {
                    console.log("owner", owner);
                    return (
                      <Card
                        key={idx}
                        bordered
                        style={{
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                          padding: "12px",
                          marginBottom: "12px",
                          width: "350px",
                        }}
                      >
                        {owner?.assetType === 2 && (
                          <p
                            style={{
                              color: "#1677ff",
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            📍 สืบลงพื้นที่
                          </p>
                        )}

                        <p>
                          <b>ชื่อ - สกุล :</b>{" "}
                          {owner?.assetCustomer?.snam || "-"}{" "}
                          {owner?.assetCustomer?.fname || "-"}{" "}
                          {owner?.assetCustomer?.lname || "-"}
                        </p>
                        <p>
                          <b>ความสัมพันธ์:</b> {owner?.relation || "-"}
                        </p>
                      </Card>
                    );
                  })}
                </div>
              </>
            ) : null}
          </Col>
        </Row>
        <Col xs={24}>
          <Divider>อัพโหลดรูปภาพ</Divider>
          <Row justify="center" gutter={[16, 16]}>
            {/* === รูปสถานที่ === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                style={{ width: "100%", body: { padding: "12px" } }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปสถานที่
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 2)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                            {/* <Button
                                                            danger
                                                            size="small"
                                                            type="primary"
                                                            onClick={() => showConfirmDeleteIMGGua([imageData])}
                                                        >
                                                            ลบรูปภาพ
                                                        </Button> */}
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                </Form.Item>
              </Card>
            </Col>

            {/* === รูปแผนที่ === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                bordered
                style={{ width: "100%" }}
                bodyStyle={{ padding: "12px" }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปแผนที่
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 3)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                </Form.Item>
              </Card>
            </Col>
            {/* === รูปใบประเมิน === */}
            <Col xs={24} sm={12} md={8}>
              <Card
                bordered
                style={{ width: "100%" }}
                bodyStyle={{ padding: "12px" }}
                title={
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    รูปใบประเมิน
                  </div>
                }
              >
                <Form.Item>
                  <Image.PreviewGroup>
                    <Space size={[10, 10]} wrap>
                      {getimages
                        ?.filter((img) => img?.type === 4)
                        .map((imageData, index) => (
                          <div
                            key={index}
                            style={{
                              flex: "0 0 auto",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Image
                              width={70}
                              src={`${GET_LOAD_IMAGE}/${imageData?.path}?token=${token}`}
                              alt={`รูปภาพ ${index}`}
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        ))}
                    </Space>
                  </Image.PreviewGroup>
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>

        <Divider />
        <Row justify="center" gutter={[16, 16]} style={{ width: "100%" }}>
          <div style={{ textAlign: "right", margin: 8 }}>
            <Space>
              <Button
                style={{ background: "red", color: "white" }}
                size="large"
                onClick={handleClose}
              >
                ปิด
              </Button>
            </Space>
          </div>
        </Row>
      </Spin>
    </Modal>
  );
}

export default ModelViewData;
